import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayEquipmentEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/equipment/`
        this.webApi = new WebApi()
    }

    async getForFiltering () {
        const equipments = await this.webApi.get(`${this.url}GetForFiltering`)
        // console.log('equipments:', equipments)
        if (equipments) {
            if (!equipments.status_code) {
                if (!equipments.error) {
                    return equipments
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${equipments.status_code}`)
            }
        }
        return null
    }

    async list (jsonObject) {
        const equipments = await this.webApi.post(`${this.url}list`, jsonObject)
        // console.log('equipments:', equipments)
        if (equipments) {
            if (!equipments.status_code) {
                if (!equipments.error) {
                    return equipments
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${equipments.status_code}`)
            }
        }
        return null
    }
}
